import { render } from "./TestKanbanTopheaderTaskCountButton.vue?vue&type=template&id=b48b01d0&scoped=true"
import script from "./TestKanbanTopheaderTaskCountButton.vue?vue&type=script&lang=js"
export * from "./TestKanbanTopheaderTaskCountButton.vue?vue&type=script&lang=js"

import "./TestKanbanTopheaderTaskCountButton.vue?vue&type=style&index=0&id=b48b01d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48b01d0"]])

export default __exports__